export const programmingLanguages = [
    {
        id: "Javascript",
        value: "Javascript",
    },
    {
        id: "Typescript",
        value: "Typescript",
    },
    {
        id: "Python",
        value: "Python",
    },
    {
        id: "Java",
        value: "Java",
    },
    {
        id: "C++",
        value: "C++"
    },
    {
        id: "HTML",
        value: "HTML"
    },
    {
        id: "CSS",
        value: "CSS"
    },
    {
        id: "SQL",
        value: "SQL"
    },
    {
        id: "Ruby",
        value: "Ruby"
    },
    {
        id: "Go",
        value: "Go"
    },
    {
        id: "Rust",
        value: "Rust"
    },
    {
        id: "PHP",
        value: "PHP"
    }
];

export const QUESTION_TYPE = {
    MULTICHOICE: 1,
    TRUEORFALSE: 2,
    DESCRIPTIVE: 3,
    RATING: 4,
    REORDER: 5,
    GRAPHICAL_SUBMISSION: 6,
    CODING: 7
};